import { Subscription } from '../../types/subscription'
import { getSubscriptions } from './getSubscriptions'

export interface GetCurrentSubscriptionOptions {
  token?: string
}

export const getCurrentSubscription = (
  options: GetCurrentSubscriptionOptions
): Promise<Subscription | undefined | null> =>
  getSubscriptions({ ...options, filter: { isCurrent: true } }).then(data => data?.[0] || null)
